import logging, { setGlobalLevel } from './logging';


const log = logging('config');

setGlobalLevel(log.WARN);

//logging('AssemblyBuilder').level = log.TRACE;
//logging('assembly').level = log.TRACE;
//logging('components').level = log.TRACE;
//logging('config').level = log.TRACE;
//logging('domain').level = log.TRACE;
//logging('main').level = log.TRACE;
//logging('ParametricCache').level = log.TRACE;
//logging('properties').level = log.TRACE;
//logging('tools').level = log.TRACE;
//logging('layout').level = log.TRACE;
//logging('selection').level = log.TRACE;
//logging('view').level = log.TRACE;
//logging('view3d').level = log.TRACE;
//logging('UnitEditorApp').level = log.TRACE;
//logging('sectionControllers').level = log.TRACE;

export const endpoint = '/test';
// export const endpoint = '/api/v1/';

export const colors = '/closet-organizers-images/models/colors'
export const geometry = '/geometry'
export const images = '/images'
export const maps = '/maps'
export const models = '/closet-organizers-images/models'
